import { Injectable } from '@angular/core';
import { JUser } from '@ascschool/interface/user';
import { Store, StoreConfig } from '@datorama/akita';
import * as storage from './storage';

export interface AuthState extends JUser {
    token: string;
}

export function createInitialAuthState(): AuthState {
    return {
        token: null,
        ...storage.getSession(),
    } as AuthState;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({
    name: 'auth'
})
export class AuthStore extends Store<AuthState> {
    constructor() {
        super(createInitialAuthState());
    }
    login(session: AuthState) {
        this.update(session);
        storage.saveSession(session);
    }
    logout() {
        storage.clearSession();
        localStorage.removeItem('selectedIndex');
        localStorage.removeItem('tabs');
        this.update(createInitialAuthState());
    }
}
